import { setOrderShipTable } from './list';
import { setOrderShipFillTable } from './fill';

export default function setTableCols (type = 'list') {
  const configs = {
    'list': setOrderShipTable.call(this),
    'fill': setOrderShipFillTable.call(this),
  };

  configs[type].forEach(v => {
    if (!v.minWidth) {
      let title = v.label || v.title;

      v.minWidth = `${title.length * 16 + (v.sortable ? 30 : 20)}px`;
    }

    v.tooltip = true;
  });

  return configs[type];
}

